import type {AudioControlBlock} from "../../Settings/AudioControlList/audioControlQuestionnaire";
import {MANUAL_CONTROL_ELEMENT_STATUS} from "./manualEvaluationControl";

export const MOCK_QUESTIONNAIRE_OPTIONS = [
    {id: 1, name: 'Анкета 1'},
    {id: 2, name: 'Анкета 2'},
    {id: 3, name: 'Анкета 3'},
    {id: 4, name: 'Анкета 4'},
];

export const MOCK_QUESTIONNAIRE_FAIL_CONDITIONS = [
    "Кидання трубки без логічного завершення (тиша, скидання дзвінка, холд тривалий без тех.інфо) штучне набивання завантаження (слухання автовідповідачів)",
    "Хамство/перехід на особистості",
    "Використання в розмові слів ненормативної лексики",
    "Підвищення голосу, негативні реакції на слова клієнта (зітхання, фрази: Я вам ще раз повторюю, скільки можна питати тощо)",
    "Дезінформування клієнта (надання некоректної/неправдивої інформації щодо умов кредиту або співпраці з компанією)",
];

export const MOCK_TRANSCRIPTION = `(00:00) Оператор: Доброго дня, мене звати Олена, внутрішній номер 417. Розмова записується. Слухаю вас.

(00:08) Клієнт: Мені телефонували з цього номера.

(00:11) Оператор: Так, усе вірно. Вам телефонували щодо важливої інформації. Скажіть, будь ласка, вам знайомий Андрій Сергійович Коваленко?

(00:22) Клієнт: Так, знайомий. А що сталося?

(00:26) Оператор: Підкажіть, будь ласка, як я можу до вас звертатися?

(00:30) Клієнт: Марина.

(00:32) Оператор: Марино, ми телефонували щодо договору, оформленого на ім'я Андрія Сергійовича. Наразі нам не вдається з ним зв'язатися. Чи могли б ви передати йому інформацію про необхідність зателефонувати за номером, з якого вам телефонували?

(00:49) Клієнт: Зараз він перебуває в іншому місті й не завжди має доступ до телефону.

(00:56) Оператор: Зрозуміла. Ви знаєте, коли з ним можна буде зв'язатися?

(01:02) Клієнт: Точно не знаю, можливо, наприкінці тижня.

(01:07) Оператор: Добре. Для продовження розмови потрібна ваша згода на взаємодію. Вона вас ні до чого не зобов'язує, і ви можете відмовитися від подальшого спілкування в будь-який момент. Ви погоджуєтеся продовжити розмову?

(01:23) Клієнт: Так, погоджуюся.

(01:25) Оператор: Дякую. Тоді, будь ласка, передайте Андрію Сергійовичу, щоб він зв'язався з нами у робочий час — з дев'ятої до вісімнадцятої.

(01:38) Клієнт: Добре, якщо він вийде на зв'язок, я передам.

(01:43) Оператор: Дякую вам за допомогу. Гарного дня.

(01:47) Клієнт: До побачення.`;

export const MOCK_BLOCKS: AudioControlBlock[] = [
    {
        id: 1,
        name: "Привітання + представлення + ідентифікація",
        weight: 40,
        comment: "",
        failCondition: null,
        isChecked: true,
        isActive: true,
        conditions: [
            {
                id: 1,
                condition: "Звучить привітання відповідно до часу доби.",
                scenario: null,
                weight: 33.3,
                failCondition: null,
                failScope: "element",
                isChecked: true,
                isActive: true,
            },
            {
                id: 2,
                condition: "Представлення (ім'я та назва компанії).",
                scenario: null,
                weight: 33.3,
                failCondition: null,
                failScope: "element",
                isChecked: true,
                isActive: true,
            },
            {
                id: 3,
                condition: "Запитання на визначення співрозмовника. агенту вдалося підтвердити, що діалог із клієнтом.",
                scenario: null,
                weight: 33.3,
                failCondition: null,
                failScope: "element",
                isChecked: true,
                isActive: true,
            },
        ],
    },
    {
        id: 2,
        name: "Мета дзвінка/Виявлення причини зупинки",
        weight: 60,
        comment: "",
        failCondition: null,
        isChecked: true,
        isActive: true,
        conditions: [
            {
                id: 4,
                condition: "Звучить мін 2 спроби схилити кл до дії/співпраці.",
                scenario: null,
                weight: 20,
                failCondition: null,
                failScope: "element",
                isChecked: true,
                isActive: true,
            },
            {
                id: 5,
                condition: "Промокоди, акції - коли немає активної позики.",
                scenario: null,
                weight: 20,
                failCondition: null,
                failScope: "element",
                isChecked: true,
                isActive: true,
            },
            {
                id: 6,
                condition: "Використання технік продажів ( мінімум 2 )",
                scenario: null,
                weight: 20,
                failCondition: null,
                failScope: "element",
                isChecked: true,
                isActive: true,
            },
            {
                id: 7,
                condition: "*Відповідає на додаткові запитання. Робимо акцент на тому, що наша пропозиція відповідає очікуванням клієнта.",
                scenario: null,
                weight: 20,
                failCondition: null,
                failScope: "element",
                isChecked: true,
                isActive: true,
            },
            {
                id: 8,
                condition: "Ставляться уточнювальні запитання про готовність клієнта скористатися пропозицією.",
                scenario: null,
                weight: 20,
                failCondition: null,
                failScope: "element",
                isChecked: true,
                isActive: true,
            },
        ],
    },
];

export const MOCK_AI_EVALUATION = {
    score: 94,
    elements: [
        {elementId: 1, description: '', tag: '', status: MANUAL_CONTROL_ELEMENT_STATUS.NO_VIOLATION, score: 33.3, isManual: false},
        {elementId: 2, description: '', tag: '', status: MANUAL_CONTROL_ELEMENT_STATUS.NO_VIOLATION, score: 33.3, isManual: false},
        {elementId: 3, description: '', tag: '', status: MANUAL_CONTROL_ELEMENT_STATUS.NO_VIOLATION, score: 33.3, isManual: false},
        {elementId: 4, description: '', tag: '', status: MANUAL_CONTROL_ELEMENT_STATUS.NO_VIOLATION, score: 20, isManual: false},
        {
            elementId: 5,
            description: 'AI: не згадано про акцію для клієнта без активної позики.',
            tag: '',
            status: MANUAL_CONTROL_ELEMENT_STATUS.VIOLATION,
            score: 0,
            isManual: false,
        },
        {elementId: 6, description: '', tag: '', status: MANUAL_CONTROL_ELEMENT_STATUS.NO_VIOLATION, score: 20, isManual: false},
        {elementId: 7, description: '', tag: '', status: MANUAL_CONTROL_ELEMENT_STATUS.NO_VIOLATION, score: 20, isManual: false},
        {elementId: 8, description: '', tag: '', status: MANUAL_CONTROL_ELEMENT_STATUS.NO_VIOLATION, score: 20, isManual: false},
    ],
    blockScores: {
        0: 100,
        1: 90,
    },
};
